export const errMsg = (err: any) => {
  const message = err?.response?.data?.message || 'An error occurred';
  const details = err?.response?.data?.details || 'An error occurred';
  const status = err?.response?.data?.status || 0;

  return { message, details, status };
};

export const errMsgNoData = (
  message?: string,
  details?: string,
  status?: number
) => {
  return {
    message: message || 'No data found',
    details: details || 'No data found',
    status: status || 0,
  };
};

export const formattedDateTime = (dateString: string): string => {
  const date = new Date(dateString);
  // Add 5 hours
  date.setHours(date.getHours() + 5);
  // Add 30 minutes
  date.setMinutes(date.getMinutes() + 30);

  return date.toLocaleString('en-US', {
    month: 'long', // numeric, 2-digit, long, short, narrow
    day: '2-digit', // numeric, 2-digit
    year: 'numeric', // numeric, 2-digit
    hour: 'numeric', // numeric, 2-digit
    minute: 'numeric', // numeric, 2-digit
    hour12: true, // Use 12-hour time
  });
};

export const getQuarterTabLable = (
  startDate: string | undefined,
  endDate: string | undefined
): string => {
  if (!startDate || !endDate) return 'Quarter';

  const startMonth = new Date(startDate).getMonth() + 1; // getMonth() returns 0-11
  const endMonth = new Date(endDate).getMonth() + 1; // getMonth() returns 0-11

  const startYear = new Date(startDate).getFullYear();

  if (startYear <= 2024) {
    if (startMonth === 1 && endMonth === 3) return 'Quarter 4';
    if (startMonth === 4 && endMonth === 6) return 'Quarter 1';
    if (startMonth === 7 && endMonth === 9) return 'Quarter 2';
    if (startMonth === 10 && endMonth === 12) return 'Quarter 3';
  } else {
    if (startMonth === 1 && endMonth === 3) return 'Quarter 1';
    if (startMonth === 4 && endMonth === 6) return 'Quarter 2';
    if (startMonth === 7 && endMonth === 9) return 'Quarter 3';
    if (startMonth === 10 && endMonth === 12) return 'Quarter 4';
  }

  return 'Quarter';
};
